export default __webpack_public_path__ + "static/grow-4f573b641a6fb39e10fcacbbad43f60f.gif";